import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D480 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D480 - Software Design and Quality Assurance
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 3.65 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            This course is easy, but the evaluators want you to write a novel
            for some reason. You're basically building a web application that
            retrieves financial data for a bank loan, with some validations, and
            then writing a whole report on implementing and testing those
            validations.
          </p>
          <p>Important Tips:
            <ul>
              <li>In the problem statement, clearly define the current problem.</li>
              <li>Repeat that problem in every section—seriously, the evaluators sent mine back because I didn't keep repeating what I already wrote.</li>
              <li>Follow this guide:<br/><a href="https://www.reddit.com/r/WGU_CompSci/comments/16c60nh/software_design_and_quality_assurance_d480_passed/" target="_blank" rel="noreferrer">🔗 Reddit Post</a></li>
              <li>Most important tip: Keep writing about how you will handle the current year validation.</li>
            </ul>
            That’s it. Just give them the long-winded explanations they want, and you’ll pass.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D480;
